import { useDeepLink } from '@p2p/pages/Payment/components/DeepLink/useDeepLink';
import { generateVtbDeepLink } from '@p2p/pages/Redirect/deeplink/deeplink.utils';
import { copyToClipboardBaseFlow } from '@p2p/pages/Redirect/RedirectPage.utils';
import { TGetOrderResponse } from '@p2p/services';
import classNames from 'classnames';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import styles from './TransferAction.module.scss';

export const TransferAction = ({ order }: { order: TGetOrderResponse | undefined }) => {
  const {
    isSupportedDeepLinkBanks,
    isFail,
    isIOS,
    isVtb,
    isAndroid,
    deepLinkTitle,
    isRmFlow,
    rmFlowLink,
  } = useDeepLink({
    order,
  });
  const isMobile = isIOS || isAndroid;
  const linkText = isRmFlow ? 'Оплатить через Тинькофф' : `Оплатить через ${deepLinkTitle}`;

  const pathToRedirect = useMemo(() => {
    if (isRmFlow) {
      return rmFlowLink;
    }

    if (isVtb && isIOS) {
      // if isVtb and isIOS, return the https vtb deep link P2P-2025
      return generateVtbDeepLink(order as TGetOrderResponse, 'https');
    }

    return `/redirect.html?orderId=${order?.id}`;
  }, [isIOS, isRmFlow, isVtb, order, rmFlowLink]);

  if (isFail || (!isSupportedDeepLinkBanks && !isRmFlow) || !isMobile) {
    return null;
  }

  const handleClick = () => {
    copyToClipboardBaseFlow(order);
  };

  return (
    <Link
      className={classNames(styles.btn, styles.btnSber)}
      to={pathToRedirect}
      onClick={handleClick}
    >
      {linkText}
    </Link>
  );
};
